import {
  faBars,
  faUser,
  faNewspaper,
  faEnvelope,
  faPhone,
  faInfoCircle,
  faTrash,
  faCheckCircle,
  faTimesCircle,
  faThumbsUp,
  faThumbsDown,
  faSort,
  faSortDown,
  faSortUp,
  faEdit,
  faArrowLeft,
  faQuestionCircle,
  faArchive,
  faUndo
} from '@fortawesome/free-solid-svg-icons';

import {
  faGitlab
} from '@fortawesome/free-brands-svg-icons';

export const fontAwesomeIcons = [
  faBars,
  faUser,
  faNewspaper,
  faEnvelope,
  faPhone,
  faInfoCircle,
  faTrash,
  faCheckCircle,
  faTimesCircle,
  faThumbsUp,
  faThumbsDown,
  faSort,
  faSortDown,
  faSortUp,
  faEdit,
  faArrowLeft,
  faQuestionCircle,
  faGitlab,
  faArchive,
  faUndo
];
